module.exports = __webpack_public_path__ + "img/icon8.5c99ab41.png";